module.exports = __webpack_public_path__ + "static/art-head-094638766cc681bf5610808a38f77c8c.png";